import { render, staticRenderFns } from "./FormOfCredit.vue?vue&type=template&id=5b7f386e&"
import script from "./FormOfCredit.vue?vue&type=script&lang=js&"
export * from "./FormOfCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports